import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import { Location } from '@reach/router';
import classNames from 'classnames';
import Highlighter from "react-highlight-words";
import { flattenNav } from '../utils/helpers';
import { ItemToAppear } from '../utils/pose';
import { Button } from 'module-tsl-ui-elements';
import { SET_SEARCH_VALUE, WIP_SECTIONS } from '../state/constants';

const NavSearching = ({ nav, searchValue, clearSearch, pathPrefix }) => {
  const flattened = flattenNav(nav, searchValue);
  return flattened.length > 0
    ? (
      <Location>
        {({ location: { pathname } }) => {
          return flattened.map((link, index) => {
            const isCurrent = pathname
              .replace(pathPrefix, '')
              .indexOf(link.path) > -1;
            const cName = classNames('nav-main-item nav-main-item--searching', {
              'nav-main-item--current': isCurrent,
              'nav-main-item--searching--child': link.isChild,
            });
            return (
              <ItemToAppear key={link.path} initialPose="closed" pose="open" after={index * 10}>
                <Link
                  to={link.path}
                  className={cName}
                >
                  <Highlighter
                    searchWords={searchValue.trim().split(/\s+/)}
                    autoEscape
                    textToHighlight={link.name}
                  />
                  {WIP_SECTIONS.includes(link.name) && <span className="wip-label">WIP</span>}
                </Link>
              </ItemToAppear>
          )});
        }}
      </Location>
    )
    : (
      <ItemToAppear initialPose="closed" pose="open" after={50}>
        <div className="not-found">
          <p>Nothing found for <b>{searchValue.trim()}</b>.</p>
          <Button theme="link-red" type="button" onClick={clearSearch}>Clear search</Button>
        </div>
      </ItemToAppear>
    );
}

export default connect(null, (dispatch) => ({
  clearSearch: () => dispatch({ type: SET_SEARCH_VALUE, payload: '' }),
}))(NavSearching);
